import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Multibrand-UI Components
import Button from '@zg-rentals/multibrand-ui/lib/Button';
import Text from '@zg-rentals/multibrand-ui/lib/Text';

import BillingConstants from 'app/shared/constants/BillingConstants';
import UserPermissionsConstants from 'app/shared/constants/UserPermissionsConstants';

import CheckSampleImage from 'app/shared/images/Paybycheck@2x.png';

import { AppSelectors, UserSelectors } from 'app/shared/selectors';

import accessUtils from 'app/shared/utils/accessUtils';

// styles
import './style.scss';

const { ZRN_BILLING_EMAIL, ROCKETSHIP_BILLING_EMAIL } = BillingConstants;
const { USER_TYPES } = UserPermissionsConstants;

const propTypes = {
    handleCloseModal: PropTypes.func,
    isRocketship: PropTypes.bool,
    cookieEnabledServices: PropTypes.object,
};

const defaultProps = {
    handleCloseModal: () => { },
    isRocketship: false,
    cookieEnabledServices: {},
};

const PaymentInfoModal = ({
    handleCloseModal,
    isRocketship,
    cookieEnabledServices,
    user,
}) => (
    <div className="PaymentInfoModalContent">
        {!accessUtils.canAccessInvoicePayments({ user, cookieEnabledServices }) && (
            <React.Fragment>
                <Text type="h3">
                    Pay by Credit Card
                </Text>
                <Text type="body">
                    Please contact Zillow Group Rentals.
                </Text>
                <Text type="body">
                    Tel: 206-757-5194, Email:&nbsp;
                    <a href={`mailto:${isRocketship ? ROCKETSHIP_BILLING_EMAIL : ZRN_BILLING_EMAIL}`}>
                        {isRocketship ? ROCKETSHIP_BILLING_EMAIL : ZRN_BILLING_EMAIL}
                    </a>
                </Text>
                <hr />
            </React.Fragment>
        )}
        <Text type="h3">
            Pay by Bank Transfer
        </Text>
        <div className="PaymentInfoModalContent-contact-info">
            <Text type="body">
                Bank Name: Silicon Valley Bank
            </Text>
            <Text type="body">
                Account Name: Zillow, Inc.
            </Text>
            <Text type="body">
                ABA / Routing Number: 121140399
            </Text>
            <Text type="body">
                Account Number: 3300755994
            </Text>
        </div>
        <hr />
        <Text type="h3">
            Pay by Check
        </Text>
        <Text type="body">
            Please include the invoice number in your check remittance
            and mail your payment to the following address:
        </Text>
        <div className="PaymentInfoModalContent-contact-info">
            <Text type="body">
                Zillow, Inc,
            </Text>
            <Text type="body">
                Dept. 3267
            </Text>
            <Text type="body">
                PO Box 123267
            </Text>
            <Text type="body">
                Dallas, TX 75312-3267
            </Text>
        </div>
        <img className="PaymentInfoModalContent-sample-check" src={CheckSampleImage} alt="Sample Check" />
        <Text type="body">
            {BillingConstants.BILLING_INFO_FOOTNOTE}
        </Text>
        <div className="PaymentInfoModalContent-footer">
            <Button onClick={handleCloseModal} type="primary">
                OK
            </Button>
        </div>
    </div>
);

PaymentInfoModal.propTypes = propTypes;
PaymentInfoModal.defaultProps = defaultProps;

const mapStateToProps = state => ({
    isRocketship: !UserSelectors.makeUser(state).roles.some(role => role === USER_TYPES.MULTIFAMILY_CUSTOMER),
    cookieEnabledServices: AppSelectors.makeCookieEnabledServices(state),
    user: UserSelectors.makeUser(state),
});

export default connect(mapStateToProps)(PaymentInfoModal);
